import { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { useSelector } from "react-redux";
import { Translate } from "../../../../Enums/Tranlate";
import { toast } from "react-toastify";
import CompanyService from "../../../../../services/Company/CompanyService";
import ScrollPagination from "../../../../common/ScrollPagination";
import BaseService from "../../../../../services/BaseService";
import BranchesService from "../../../../../services/Company/BranchesService";

const AddCompanyModal = ({
	addModal,
	setAddModal,
	item,
	setShouldUpdate,
	Service,
}) => {
	const [formData, setFormData] = useState({
		title: "",
		description: "",
		fileUrl: "",
		companyId: "",
		branchId: "",
	});
	const [isAdd, setIsAdd] = useState(false);
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth.lang);
	const companyService = new CompanyService();
	const branchesService = new BranchesService();

	useEffect(() => {
		if (Object.keys(item)?.length === 0) {
			setIsAdd(true);
		} else {
			Service.find(item?.id).then((res) => {
				if (res?.status) {
					const response = res?.data?.data;
					setIsAdd(false);
					setFormData({
						title: response?.title,
						description: response?.description,
						fileUrl: response?.fileUrl,
					});
				}
			});
		}
	}, [item]);

	const fileHandler = (e) => {
		let files = e.target.files;
		const filesData = Object.values(files);
		if (!!filesData?.length) {
			setLoading(true);
			new BaseService()
				.postUpload(filesData[0])
				.then((res) => {
					// if (res?.status === 201) {
					// 	setFormData({
					// 		...formData,
					// 		[name]: res?.data?.data?.uploadedFiles[0]?.url || "",
					// 	});
					// }
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	};

	const submit = (e) => {
		e.preventDefault();
		let data = {
			...formData,
			branchId: formData?.branchId?.value || "",
			fileUrl: formData?.fileUrl?.includes("http") ? formData?.fileUrl : "",
			companyId: formData?.companyId?.value,
		};

		setLoading(true);
		if (isAdd) {
			Service.create(data)
				?.then((res) => {
					if (res && res?.status === 201) {
						toast.success(`Company Policy Added Successfully`);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		} else {
			Service.update(item?.id, data)
				?.then((res) => {
					if (res && res?.status === 200) {
						toast.success(`Company Policy Updated Successfully`);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	};

	return (
		<Modal
			className={
				lang === "en" ? "en fade addDepartment" : "ar fade addDepartment"
			}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={addModal}
			onHide={() => {
				setAddModal();
			}}>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Modal.Body>
					<Row>
						<Col md={12} className="mb-2">
							<div className="d-flex justify-content-between">
								<p
									className="mb-0"
									style={{
										fontWeight: "600",
										color: "#000",
										fontSize: "22px",
									}}>
									{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
									{Translate[lang]?.company_policy}
								</p>
								<Button
									variant=""
									className="close"
									style={{
										right: lang === "en" ? "0" : "auto",
										left: lang === "ar" ? "0" : "auto",
									}}
									onClick={() => {
										setAddModal();
									}}>
									<span style={{ fontSize: "22px" }}>&times;</span>
								</Button>
							</div>
						</Col>
						{/* Legal Name */}
						<Col md={12}>
							<AvField
								label={Translate[lang]?.title}
								type="text"
								placeholder={Translate[lang]?.title}
								name="title"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.title}
								onChange={(e) =>
									setFormData({ ...formData, title: e.target.value })
								}
							/>
						</Col>
						{/* Description */}
						<Col md={12}>
							<AvField
								label={Translate[lang]?.description}
								type="text"
								placeholder={Translate[lang]?.description}
								bsSize="lg"
								name="description"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.description}
								onChange={(e) =>
									setFormData({ ...formData, description: e.target.value })
								}
							/>
						</Col>
						{/* Company Id*/}
						<Col md={12} className="mb-3">
							<label>{Translate[lang].company}</label>
							<ScrollPagination
								Service={companyService}
								value={formData?.companyId}
								nameVal="legalName"
								setData={(e) =>
									setFormData((prev) => ({ ...prev, companyId: e }))
								}
							/>
						</Col>
						{/* Branch */}
						<Col md={12}>
							<label>{Translate[lang].branch}</label>
							<ScrollPagination
								Service={branchesService}
								value={formData?.branchId}
								nameVal="name"
								setData={(e) =>
									setFormData((prev) => ({ ...prev, branchId: e }))
								}
							/>
						</Col>
						<Col md={12} className="mt-3">
							<label className="text-label mb-0">{Translate[lang]?.file}</label>
							<div className="upload">
								<input
									type="file"
									name="fileUrl"
									id="fileUrl"
									onChange={(e) => fileHandler(e)}
								/>
								<p>{Translate[lang].upload_files}</p>
								{!formData?.fileUrl ? (
									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M16.44 8.9C20.04 9.21 21.51 11.06 21.51 15.11V15.24C21.51 19.71 19.72 21.5 15.25 21.5H8.73998C4.26998 21.5 2.47998 19.71 2.47998 15.24V15.11C2.47998 11.09 3.92998 9.24 7.46998 8.91"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										<path
											d="M12 15V3.62"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										<path
											d="M15.35 5.85L12 2.5L8.65002 5.85"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
									</svg>
								) : (
									<svg
										width="24"
										height="24"
										viewBox="0 0 16 16"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M8 1.33333C4.32667 1.33333 1.33334 4.32667 1.33334 8C1.33334 11.6733 4.32667 14.6667 8 14.6667C11.6733 14.6667 14.6667 11.6733 14.6667 8C14.6667 4.32667 11.6733 1.33333 8 1.33333ZM11.1867 6.46667L7.40667 10.2467C7.31334 10.34 7.18667 10.3933 7.05334 10.3933C6.92 10.3933 6.79334 10.34 6.7 10.2467L4.81334 8.36C4.62 8.16667 4.62 7.84667 4.81334 7.65333C5.00667 7.46 5.32667 7.46 5.52 7.65333L7.05334 9.18667L10.48 5.76C10.6733 5.56667 10.9933 5.56667 11.1867 5.76C11.38 5.95333 11.38 6.26667 11.1867 6.46667Z"
											fill="#21AA37"
										/>
									</svg>
								)}
							</div>
						</Col>
						{!!formData.fileUrl && (
							<Col md={3}>
								<div>
									<i
										className="la la-trash text-danger"
										onClick={() => {
											setFormData((prev) => ({ ...prev, fileUrl: "" }));
										}}></i>
									{formData.fileUrl.includes("pdf") ? (
										<a href={formData.fileUrl} target="_blank" rel="noreferrer">
											<i
												className="la la-file-pdf d-block"
												style={{ fontSize: "6rem" }}></i>
										</a>
									) : (
										<img
											src={formData.fileUrl}
											alt="fileUrl"
											className="w-100"
										/>
									)}
								</div>
							</Col>
						)}
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant="primary"
						type="submit"
						className="w-100"
						disabled={loading}>
						{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
						{Translate[lang]?.company_policy}
					</Button>
				</Modal.Footer>
			</AvForm>
		</Modal>
	);
};

export default AddCompanyModal;
